import { render, staticRenderFns } from "./SpecialIssues.vue?vue&type=template&id=7e9a62a1&scoped=true"
import script from "./SpecialIssues.vue?vue&type=script&lang=js"
export * from "./SpecialIssues.vue?vue&type=script&lang=js"
import style0 from "./SpecialIssues.vue?vue&type=style&index=0&id=7e9a62a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9a62a1",
  null
  
)

export default component.exports